"use strict";

var managerSelectFormDirective = angular.module('managerSelectFormDirective', []);

managerSelectFormDirective.directive('managerSelectForm', function (){

    return{
        restrict: 'E',
        scope: {
            processUser: '&'
        },
        templateUrl: 'js/directives/templates/managerSelectForm.tpl.html',
        link: function (scope, element, attrs) {

        },
        controller: ['$scope', 'serviceRequestSignIn','serviceRequestSignOut', function($scope, serviceRequestSignIn, serviceRequestSignOut){
            $scope.widgetInfo = {
                step: 0
            };

            $scope.selectedUser = {};
            $scope.users = [];

            if(serviceRequestSignIn.get().hasOwnProperty("serviceRequest"))
            {
                serviceRequestSignIn.get().serviceRequest.$get("store").then(function (store) {
                    store.$get("users").then(function (resource) {
                        resource.$get("userList").then(function (users) {
                            $scope.users = users;
                        });
                    });
                });
            }
            else
            {
                serviceRequestSignOut.get().serviceRequest.$get("store").then(function (store) {
                    store.$get("users").then(function (resource) {
                        resource.$get("userList").then(function (users) {
                            $scope.users = users;
                        });
                    });
                });
            }

            $scope.selectUser = function(index){
                $scope.selectedUser = $scope.users[index];
                $scope.processUser()($scope.selectedUser);
                serviceRequestSignIn.setSignedInBy($scope.selectedUser.username);
                $scope.widgetInfo.step++;
            }

            $scope.goBack = function(){
                $scope.widgetInfo.step--;
            }

            $scope.continue = function(){
                $scope.$parent.next();
            }
        }]
    };

});

